import $ from 'jquery';
import 'slick-slider';

$(document).ready(() => {
	$('.hero-carousel__slider').slick({
		fade: true,
		arrows: false,
		dots: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		autoplaySpeed: 5000,
	});
	$('.hero-carousel__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		const $nextSlide = $(slick.$slides[nextSlide]);
		const caption = $nextSlide.find('[data-caption]').data('caption');
		$('.hero-carousel__text p').fadeOut(300, function(){
			$(this).text(caption).fadeIn(300)
		});
	});
});
